import * as yup from 'yup';
import { sharedEuroinsFields } from '../shared/sharedEuroinsSchema';

export const carEuroinsSchemaBuilder = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => yup.object({
    ...sharedEuroinsFields(
        firstDriverAdditionalPremiumAge,
        secondDriverAdditionalPremiumAge,
        firstDriverAdditionalPremiumLicenseYears,
        secondDriverAdditionalPremiumLicenseYears,
        legalEntity,
        secondDriver,
        discountEntity,
        vehicleType
    ),
});

export default carEuroinsSchemaBuilder;
